/**
 * Inline markup of the legal texts (packages/shared/src/legal-docs.ts): **bold**, `code`, [label](/path)
 * and the visible [KITÖLTENDŐ: …] marker for data the operator has not supplied yet.
 */
import type { ReactNode } from 'react';
import { PENDING_PREFIX } from '@galaxis/shared';

const TOKEN = /(\*\*[^*]+\*\*|`[^`]+`|\[[^\]]+\]\([^)\s]+\)|\[KITÖLTENDŐ[^\]]*\])/g;

export function renderInline(text: string): ReactNode[] {
  return text.split(TOKEN).filter(Boolean).map((part, i) => {
    if (part.startsWith('**')) return <strong key={i} className="text-slate-100">{part.slice(2, -2)}</strong>;
    if (part.startsWith('`')) return <code key={i} className="font-mono text-[0.85em] px-1 rounded bg-black/30 text-sky-200 break-all">{part.slice(1, -1)}</code>;
    if (part.startsWith(PENDING_PREFIX)) {
      return <mark key={i} className="legal-pending" data-testid="legal-pending">{part}</mark>;
    }
    const link = part.match(/^\[([^\]]+)\]\(([^)\s]+)\)$/);
    if (link) return <a key={i} href={link[2]} className="text-accent underline underline-offset-2">{link[1]}</a>;
    return part;
  });
}
